function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.33 6.693l.42-1.377a1 1 0 111.913.585l-1.17 3.825a1 1 0 01-1.248.664L15.42 9.22a1 1 0 11.585-1.912l1.672.511A7.381 7.381 0 004.685 9.083l-.26.633a1 1 0 11-1.85-.758l.26-.633A9.381 9.381 0 0119.33 6.693zM3.808 17.306l-.327 1.311a1 1 0 11-1.94-.484l.967-3.88a1 1 0 011.265-.716l3.828.954a1 1 0 01-.484 1.941l-1.786-.445a7.383 7.383 0 0013.216-1.792 1 1 0 111.906.608 9.382 9.382 0 01-16.645 2.503z"
});

var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "1 2 21 20",
    fill: "#6682A5"
  }, props), _ref);
};

export default SvgRefresh;